import {
  useLazyGetSqFollowupLetterQuery,
  useLazyGetSqPublishFollowupLetterQuery,
  useLazySelectSqFollowupLetterQuery,
  useSignSqFollowupLetterMutation,
  useUpdateSqFollowupLetterMutation,
  usePublishSqFollowupLetterMutation,
  useCreateNewVersionMutation
} from 'src/services/sqFollowupLetterAPI';

export const useSqFollowupLetter = () => {
  const [
    getSqFollowupLetter,
    {
      data: sqFollowupLetterData,
      isLoading: sqFollowupLetterIsLoading,
      isError: sqFollowupLetterIsError,
      error: sqFollowupLetterError,
      isSuccess: sqFollowupLetterIsSuccess
    }
  ] = useLazyGetSqFollowupLetterQuery();

  const [
    getSqPublishFollowupLetter,
    {
      data: sqPublishFollowupLetterData,
      isLoading: sqPublishFollowupLetterIsLoading,
      isError: sqPublishFollowupLetterIsError,
      error: sqPublishFollowupLetterError,
      isSuccess: sqPublishFollowupLetterIsSuccess
    }
  ] = useLazyGetSqPublishFollowupLetterQuery();

  const [
    selectSqFollowupLetter,
    {
      data: selectSqFollowupLetterData,
      isLoading: selectSqFollowupLetterIsLoading,
      isError: selectSqFollowupLetterIsError,
      error: selectSqFollowupLetterError,
      isSuccess: selectSqFollowupLetterIsSuccess
    }
  ] = useLazySelectSqFollowupLetterQuery();

  const [
    updateSqFollowupLetter,
    {
      data: updateSqFollowupLetterData,
      isLoading: updateSqFollowupLetterIsLoading,
      isError: updateSqFollowupLetterIsError,
      error: updateSqFollowupLetterError,
      isSuccess: updateSqFollowupLetterIsSuccess
    }
  ] = useUpdateSqFollowupLetterMutation();

  const [
    signSqFollowupLetter,
    {
      data: signSqFollowupLetterData,
      isLoading: signSqFollowupLetterIsLoading,
      isError: signSqFollowupLetterIsError,
      error: signSqFollowupLetterError,
      isSuccess: signSqFollowupLetterIsSuccess
    }
  ] = useSignSqFollowupLetterMutation();

  const [
    publishSqFollowupLetter,
    {
      data: publishSqFollowupLetterData,
      isLoading: publishSqFollowupLetterIsLoading,
      isError: publishSqFollowupLetterIsError,
      error: publishSqFollowupLetterError,
      isSuccess: publishSqFollowupLetterIsSuccess
    }
  ] = usePublishSqFollowupLetterMutation();

  const [
    createNewVersion,
    {
      data: createNewVersionData,
      isLoading: createNewVersionIsLoading,
      isError: createNewVersionIsError,
      error: createNewVersionError,
      isSuccess: createNewVersionIsSuccess
    }
  ] = useCreateNewVersionMutation();

  return {
    getSqFollowupLetter,
    sqFollowupLetterData,
    sqFollowupLetterIsLoading,
    sqFollowupLetterIsError,
    sqFollowupLetterError,
    sqFollowupLetterIsSuccess,
    selectSqFollowupLetter,
    selectSqFollowupLetterData,
    selectSqFollowupLetterIsLoading,
    selectSqFollowupLetterIsError,
    selectSqFollowupLetterError,
    selectSqFollowupLetterIsSuccess,
    updateSqFollowupLetter,
    updateSqFollowupLetterData,
    updateSqFollowupLetterIsLoading,
    updateSqFollowupLetterIsError,
    updateSqFollowupLetterError,
    updateSqFollowupLetterIsSuccess,
    signSqFollowupLetter,
    signSqFollowupLetterData,
    signSqFollowupLetterIsLoading,
    signSqFollowupLetterIsError,
    signSqFollowupLetterError,
    signSqFollowupLetterIsSuccess,
    publishSqFollowupLetter,
    publishSqFollowupLetterData,
    publishSqFollowupLetterIsLoading,
    publishSqFollowupLetterIsError,
    publishSqFollowupLetterError,
    publishSqFollowupLetterIsSuccess,
    getSqPublishFollowupLetter,
    sqPublishFollowupLetterData,
    sqPublishFollowupLetterIsLoading,
    sqPublishFollowupLetterIsError,
    sqPublishFollowupLetterError,
    sqPublishFollowupLetterIsSuccess,
    createNewVersion,
    createNewVersionData,
    createNewVersionIsLoading,
    createNewVersionIsError,
    createNewVersionError,
    createNewVersionIsSuccess
  };
};
